import { React, useEffect, useRef, useContext, useState } from 'react';
import './form.css';
import { useNavigate, Link } from 'react-router-dom';
import SocialContext from '../../context/SocialContext';
import Alertjs from '../../components/alert/Alert';
import { CircularProgress } from '@material-ui/core';
import Topbar from '../../components/topbar/Topbar';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function Rigester() {
    const navigate = useNavigate();
    const { isfetching, showalert, setshowalert, setalertType, setalertmessage, registerfun, user, scrolltoTopfun } = useContext(SocialContext);

    useEffect(() => {
        if (localStorage.getItem('currentUID')) {
            navigate('/');
        }
        scrolltoTopfun();
        window.document.title = 'SocialHub - SignUp';
    }, [user])

    const username = useRef();
    const email = useRef();
    const password = useRef();
    const confirmpassword = useRef();

    // function for submiting a form 
    const onsubmitfun = (event) => {
        event.preventDefault();
        if (password.current.value !== confirmpassword.current.value) {
            setshowalert(true);
            setalertType('warning');
            setalertmessage("Opps! Password do not match");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        } else {
            registerfun(username.current.value, email.current.value, password.current.value);
        }
    }

    const onclickfun = () => {
        // console.log('enter in showclickfun');
        if (email.current.value == "" || password.current.value == "" || username.current.value == "") {
            setshowalert(true);
            setalertType('warning');
            setalertmessage("Please enter user credentials and try again..");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        }
    }

    const fun = () => {
        confirmpassword.current.setCustomValidity("Passwords don't match!");
        console.log(password.current.value, confirmpassword.current.value);
    }

    const [visible1, setvisible1] = useState(false);
    const [visible2, setvisible2] = useState(false);
    const [inputType1, setinputType1] = useState('password');
    const [inputType2, setinputType2] = useState('password');
    const toggleVisiblefun = (number) => {
        if (number == 1) {
            setvisible1(!visible1);
            if (inputType1 == 'password') {
                setinputType1('text')
            } else {
                setinputType1('password')
            }
        } else {
            setvisible2(!visible2);
            if (inputType2 == 'password') {
                setinputType2('text')
            } else {
                setinputType2('password')
            }
        }
    }

    return (
        <>
            <Topbar />
            {showalert ? <div style={{ height: '48px', 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
                <Alertjs />
            </div> : ""}

            <div className="back">
                <div className='formbody'>
                    <div className="sign-up-form">
                        <h1> Sign Up</h1>
                        <form onSubmit={onsubmitfun}>
                            <p className='formtitle'>Username*</p>
                            <input autoComplete='off' ref={username} name='username' required type="text" className='input-box' style={{ 'marginBottom': '5px' }} placeholder='Username' />
                            <p className='formtitle'>Email*</p>
                            <input autoComplete='off' ref={email} name='email' required type="email" className='input-box' style={{ 'marginBottom': '5px' }} placeholder='Email-Id' />
                            <p className='formtitle'>Password*</p>
                            <div className='passworddiv' style={{ 'marginBottom': '15px' }}><input autoComplete='off' style={{ border: 'none', margin: '0px' }} ref={password} name='password' required minLength={6} maxLength={12} type={inputType1} className='input-box' placeholder='Password' />{visible1 ? <VisibilityIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={() => { toggleVisiblefun(1) }} /> : <VisibilityOffIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={() => { toggleVisiblefun(1) }} />}</div>
                            <p className='formtitle'>Confirm Password*</p>
                            <div className='passworddiv'><input autoComplete='off' style={{ border: 'none', margin: '0px' }} ref={confirmpassword} name='confpassword' required minLength={6} maxLength={12} type={inputType2} className='input-box' placeholder='Conform Password' />{visible2 ? <VisibilityIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={() => { toggleVisiblefun(2) }} /> : <VisibilityOffIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={() => { toggleVisiblefun(2) }} />}</div>
                            <button type='submit' onClick={onclickfun} style={{ 'marginTop': '20px' }} className='signup-btn formbutton'>{isfetching ? <CircularProgress color="white" size="17px" /> : "Sign up"}</button>
                        </form>
                        <hr className='formhr' />
                        <p className='p'>Already have an account ? <Link style={{ 'textDecoration': 'none' }} to="/login">  Sign in</Link></p>
                    </div>
                </div>
                <div className="copyright" style={{'position':'fixed','bottom':'1px','width':'100%','marginTop':'5%','zIndex':'-1'}}>
                    <p style={{ 'textAlign': 'center', opacity: '0.9','width':'100%' }}>Copyright ©2022-Alok.info | All rights reserved</p>
                </div>
            </div>
        </>
    );
}